var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-filter-wrapper filter col-12",class:_vm.open ? 'open' : 'closed'},[(_vm.title)?_c('h3',{staticClass:"virtual-p font-weight-bold",on:{"click":function($event){_vm.open = ! _vm.open}}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }